
/*
================================================================================

  "Main Hero" section

================================================================================
*/
import Swiper from 'swiper';

const MainHero = (() => {
  const initSlider = function() {
    const mainHeroElem = document.querySelector('.main-hero');
    const sliderElem = mainHeroElem.querySelector('.main-hero__slider');
    const paginationElem = mainHeroElem.querySelector('.main-hero__pagination');

    new Swiper(sliderElem, {
      autoplay: {
        delay: 5000
      },
      effect: 'fade',
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      pagination: {
        el: paginationElem,
        type: 'bullets',
        bulletClass: 'slider-pagination__bullet',
        bulletActiveClass: 'js-active',
        modifierClass: 'slider-pagination--',
        currentClass: 'js-current',
        totalClass: 'js-total',
        hiddenClass: 'js-hidden',
        clickableClass: 'js-clickable'
      }
    });
  };

  const initEventListeners = function() {
    if (document.querySelector('.main-hero')) {
      initSlider();
    }
  };

  const init = function() {
    initEventListeners();
  };

  return {
    init: init
  };

})();

export default MainHero;
